import { render, staticRenderFns } from "./ansMov.vue?vue&type=template&id=b8aaf630&scoped=true"
import script from "./ansMov.vue?vue&type=script&lang=js"
export * from "./ansMov.vue?vue&type=script&lang=js"
import style0 from "./ansMov.vue?vue&type=style&index=0&id=b8aaf630&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b8aaf630",
  null
  
)

export default component.exports